import {useRef} from "react";
import {useResizeObserver} from "usehooks-ts";

export function useElementSize<T extends HTMLElement = HTMLElement>() {
  const ref = useRef<T>(null);
  const size = useResizeObserver<T>({ref, box: "border-box"});
  return [ref, size] as const;
}
